import { useTranslation } from "@redotech/redo-i18n";
import SearchIcon from "@redotech/redo-icons/search-sm_filled.svg";
import { CommandPalette } from "@redotech/redo-web/command-palette/components/command-palette";
import { useMetaKey } from "@redotech/redo-web/command-palette/hooks/use-meta-key";
import { Button } from "@redotech/redo-web/components/ui/button";
import { PopoverTrigger } from "@redotech/redo-web/components/ui/popover";
import { memo } from "react";

export const SearchButton = memo(function SearchButton() {
  const { t } = useTranslation();
  const metaKey = useMetaKey();

  return (
    <CommandPalette>
      <PopoverTrigger asChild>
        <Button
          className="max-w-[520px] w-full shrink min-w-0 opacity-90 hover:opacity-100 box-shadow-sm !px-2 !rounded-[6px]"
          size="sm"
          variant="default"
        >
          <SearchIcon className="size-3 text-[#d6d6d6]" />
          <span className="text-xs text-[#d6d6d6] font-normal">
            {t("Search", {
              context: "button that opens global navigation search",
            })}
          </span>
          <span className="ml-auto text-xs text-[#d6d6d6] font-normal opacity-70 bg-transparent rounded-[4px] border border-white/20 px-1 h-5 flex items-center">
            {metaKey}K
          </span>
        </Button>
      </PopoverTrigger>
    </CommandPalette>
  );
});
